import { Drawer, DrawerProps as MuiDrawerProps } from '@mui/material';
import React, { forwardRef, useCallback } from 'react';

import { CloseButton } from '../CloseButton/CloseButton';

interface DrawerProps extends MuiDrawerProps {
  onClose?: {
    bivarianceHack(event, reason: 'backdropClick' | 'escapeKeyDown' | 'closeButtonClick'): void;
  }['bivarianceHack'];
  closeButton?: boolean;
}

/**
 * @version [AIV]{version}[/AIV]
 * @author [SFP](https://gitlab.sfp.berlin/products/sparkasse.de/portals)
 */
export const Flyout = forwardRef<HTMLDivElement, DrawerProps>(({ children, closeButton = true, ...props }, ref) => {
  const onClose = useCallback(
    (event) => {
      if (props.onClose) {
        props.onClose(event, 'closeButtonClick');
      }
    },
    [props]
  );

  return (
    <Drawer ref={ref} {...props}>
      {closeButton && <CloseButton onClick={onClose} aria-label="Schließen" />}
      {children}
    </Drawer>
  );
});

Flyout.displayName = 'ref(Flyout)';
